/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "../models";
import * as Mappers from "../models/exportModelMappers";
import * as Parameters from "../models/parameters";
import { PolandPharmacyRxAPIContext } from "../polandPharmacyRxAPIContext";

/** Class representing a ExportModel. */
export class ExportModel {
  private readonly client: PolandPharmacyRxAPIContext;

  /**
   * Create a ExportModel.
   * @param {PolandPharmacyRxAPIContext} client Reference to the service client.
   */
  constructor(client: PolandPharmacyRxAPIContext) {
    this.client = client;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.ExportModelGetZPOSPListResponse>
   */
  getZPOSPList(options?: Models.ExportModelGetZPOSPListOptionalParams): Promise<Models.ExportModelGetZPOSPListResponse>;
  /**
   * @param callback The callback
   */
  getZPOSPList(callback: msRest.ServiceCallback<Models.FileResultDto>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getZPOSPList(options: Models.ExportModelGetZPOSPListOptionalParams, callback: msRest.ServiceCallback<Models.FileResultDto>): void;
  getZPOSPList(options?: Models.ExportModelGetZPOSPListOptionalParams | msRest.ServiceCallback<Models.FileResultDto>, callback?: msRest.ServiceCallback<Models.FileResultDto>): Promise<Models.ExportModelGetZPOSPListResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getZPOSPListOperationSpec,
      callback) as Promise<Models.ExportModelGetZPOSPListResponse>;
  }

  /**
   * @param [options] The optional parameters
   * @returns Promise<Models.ExportModelGetTemplateNoteResponse>
   */
  getTemplateNote(options?: Models.ExportModelGetTemplateNoteOptionalParams): Promise<Models.ExportModelGetTemplateNoteResponse>;
  /**
   * @param callback The callback
   */
  getTemplateNote(callback: msRest.ServiceCallback<Models.FileResultDto>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getTemplateNote(options: Models.ExportModelGetTemplateNoteOptionalParams, callback: msRest.ServiceCallback<Models.FileResultDto>): void;
  getTemplateNote(options?: Models.ExportModelGetTemplateNoteOptionalParams | msRest.ServiceCallback<Models.FileResultDto>, callback?: msRest.ServiceCallback<Models.FileResultDto>): Promise<Models.ExportModelGetTemplateNoteResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getTemplateNoteOperationSpec,
      callback) as Promise<Models.ExportModelGetTemplateNoteResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const getZPOSPListOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "export/Export/export/ZPOSP",
  queryParameters: [
    Parameters.checked,
    Parameters.fileType,
    Parameters.correctReport
  ],
  responses: {
    200: {
      bodyMapper: Mappers.FileResultDto
    },
    default: {}
  },
  serializer
};

const getTemplateNoteOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "export/Export/export/Note",
  queryParameters: [
    Parameters.checked,
    Parameters.fileType
  ],
  responses: {
    200: {
      bodyMapper: Mappers.FileResultDto
    },
    default: {}
  },
  serializer
};
